import { ssrApi } from 'api/ssr';
import { ParsedUrlQuery } from 'querystring';

import { IProvider, ISlot } from 'constants/types';

import { ProviderPageById } from 'components/template/provider';
import { listSlotsByProvider } from 'lib/api/slots';
import { getItemIdentifier } from 'utils/slug';
import {
  isValidEntity,
  notFoundResult,
  unwrapEntity,
} from 'utils/ssr-not-found';

type ProviderPageProps = {
  provider: IProvider;
  initialSlots: ISlot[];
  initialOtherProviders: IProvider[];
  initialProvidersCount: string | number;
};

export default function ProviderPage({
  provider,
  initialSlots,
  initialOtherProviders,
  initialProvidersCount,
}: ProviderPageProps) {
  return (
    <ProviderPageById
      provider={provider}
      initialSlots={initialSlots}
      initialOtherProviders={initialOtherProviders}
      initialProvidersCount={initialProvidersCount}
    />
  );
}

export async function getServerSideProps({ query }: { query: ParsedUrlQuery }) {
  const providerId = query.id?.toString();

  const [provider, providersList, slotsData] = await Promise.all([
    ssrApi.providers.getById(providerId),
    ssrApi.providers.list(),
    listSlotsByProvider(providerId ?? ''),
  ]);

  if (!isValidEntity(provider)) {
    return notFoundResult();
  }

  const resolvedProvider = unwrapEntity(provider)!;
  const currentProviderId = getItemIdentifier(resolvedProvider);

  return {
    props: {
      provider: resolvedProvider,
      initialSlots: slotsData?.results ?? [],
      initialOtherProviders: (providersList?.results ?? []).filter(
        (item) => getItemIdentifier(item) !== currentProviderId
      ),
      initialProvidersCount: providersList?.count ?? '',
    },
  };
}
